import { Menu, MenuButton, MenuItem, MenuItems, Transition } from "@headlessui/react"
import { useContext } from "react"
import { Bars3Icon } from "@heroicons/react/24/outline"
import { classNames } from "../lib"
import { BookNavModalContext } from "./Contexts"

export type NavigationItemOnClick = (
  evt?: React.MouseEvent<HTMLAnchorElement>,
  close?: () => void
) => void

export interface NavigationItem {
  label: string
  href: string
  className?: string
  onClick?: NavigationItemOnClick
  divider?: boolean
}

const MenuNavigation = ({ align }: { align?: string } = { align: "right" }) => {
  const { setIsOpen: setOpenBookNav } = useContext(BookNavModalContext)
  const pageType = document.querySelector<HTMLElement>("[data-type]")?.dataset.type ?? ""
  const navigation: NavigationItem[] = [
    {
      label: "Read the Bible",
      href: "",
      className: "font-medium",
      onClick: (evt, close) => {
        evt?.preventDefault()
        if (close) {
          close()
        }
        setOpenBookNav(true)
      },
    },
    { label: "Home", href: "/index.html" },
  ]

  return (
    <div className="not-prose flex items-center font-sans">
      <Menu
        as="div"
        className={classNames("inline-flex", align === "right" ? "text-right" : "text-left")}
      >
        <MenuButton
          aria-label="Menu"
          className={classNames(
            "inline-flex items-center rounded-md",
            "text-sm text-white",
            "focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
          )}
        >
          <div className="inline-flex justify-center px-2 py-1 align-middle text-white hover:text-slate-300">
            <Bars3Icon className="size-8" />
            <span className="sr-only">Open Menu</span>
          </div>
        </MenuButton>
        <Transition
          as="div"
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <MenuItems
            className={classNames(
              "absolute top-12 mt-2 w-54",
              "divide-y divide-gray-100 rounded-md bg-white shadow-lg",
              "ring-1 ring-black ring-opacity-5 focus:outline-none",
              align === "right" ? "right-3 origin-top-right" : "left-0 origin-top-left"
            )}
          >
            <div className="p-1">
              {navigation.map(link =>
                link.divider ? (
                  <div className="mb-1 border" key={link.label} />
                ) : (
                  <MenuItem key={link.label} as="div">
                    {({ active, close }) => (
                      <a
                        key={link.href}
                        href={link.href}
                        className={classNames(
                          active
                            ? "bg-rose-500/80 text-white"
                            : pageType !== "book" && link.label !== "Read the Bible"
                              ? "bg-rose-500 text-white"
                              : "text-gray-900",
                          "group flex w-full items-center rounded-md px-2 py-2 mb-1 last:mb-0 no-underline text-sm",
                          link.className ?? ""
                        )}
                        onClick={
                          link.onClick
                            ? evt => {
                                link.onClick && link.onClick(evt, close)
                              }
                            : undefined
                        }
                      >
                        {link.label}
                      </a>
                    )}
                  </MenuItem>
                )
              )}
            </div>
          </MenuItems>
        </Transition>
      </Menu>
    </div>
  )
}

export default MenuNavigation
